import Button from "../Button/Button";
import { Filter } from "../Icon/Icon";
import styles from "./FilterButton.module.scss";

function FilterButton({
  filterCount,
  open,
  clearFilters,
}: {
  filterCount: number;
  open: () => void;
  clearFilters: () => void;
}) {
  return (
    <div className={styles.container}>
      <Button
        leftIcon={<Filter />}
        variant={filterCount ? "secondary" : "outline"}
        onClick={open}
      >
        {filterCount ? `Filters (${filterCount})` : "Filters"}
      </Button>
      {filterCount > 0 && (
        <Button variant="link" onClick={clearFilters}>
          Clear filters
        </Button>
      )}
    </div>
  );
}

export default FilterButton;
